import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Moon, Sun, PartyPopper } from 'lucide-react';
export function TransformationTimeline() {
  const timeline = [{
    day: 'Domingo 8 PM',
    title: 'Cero ansiedad',
    desc: 'Sabes exactamente qué comprar y qué preparar. La cocina está limpia y tú estás descansando.',
    icon: <Moon className="w-5 h-5" data-id="element-263" />,
    accent: 'bg-sage-500',
    badgeBg: 'bg-sage-500 text-white',
    shadow: 'shadow-[0_8px_30px_-4px_rgba(122,175,135,0.45)]',
    borderColor: 'border-sage-400',
    emoji: '🧘‍♀️'
  }, {
    day: 'Lunes 7 AM',
    title: 'Paz matutina',
    desc: 'Terminas la lonchera en 8 minutos. Tienes tiempo de tomarte tu café caliente antes de salir.',
    icon: <Sun className="w-5 h-5" data-id="element-264" />,
    accent: 'bg-naranja-500',
    badgeBg: 'bg-naranja-500 text-white',
    shadow: 'shadow-[0_8px_30px_-4px_rgba(251,133,0,0.4)]',
    borderColor: 'border-naranja-300',
    emoji: '☕'
  }, {
    day: 'Viernes 3 PM',
    title: 'Misión cumplida',
    desc: 'El niño regresa con la lonchera VACÍA (porque ahora la comida es variada, rica y fácil de comer).',
    icon: <PartyPopper className="w-5 h-5" data-id="element-265" />,
    accent: 'bg-naranja-500',
    badgeBg: 'bg-naranja-500 text-white',
    shadow: 'shadow-[0_8px_30px_-4px_rgba(242,139,110,0.45)]',
    borderColor: 'border-naranja-300',
    emoji: '🎉'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 40,
      scale: 0.92
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: 'spring',
        stiffness: 180,
        damping: 18
      }
    }
  };
  return <section className="py-10 px-4 bg-sage-50" data-id="element-266">
      <div className="max-w-4xl mx-auto" data-id="element-267">
        {/* Hero image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center mb-10" data-id="element-268">
          <div className="w-full max-w-2xl rounded-2xl overflow-hidden shadow-xl border-4 border-white" data-id="element-269">
            <img src="https://cdn.magicpatterns.com/uploads/opaK2jk8BeeGLyTZJeMiXa/5.png" alt="Madre preparando loncheras saludables con el Kit de Supervivencia" className="w-full h-auto object-cover" data-id="element-270" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-271">
          <h2 className="text-2xl md:text-3xl font-black text-charcoal-900 mb-2" data-id="element-272">
            ¿Qué cambia en tu vida con este Kit?
          </h2>
          <p className="text-base text-charcoal-600 font-medium" data-id="element-273">
            Al tercer día de usar el sistema, esto es lo que notarás:
          </p>
        </motion.div>

        <div className="relative" data-id="element-274">
          {/* Connecting line for desktop */}
          <div className="hidden md:flex absolute top-1/2 left-[8%] right-[8%] -translate-y-1/2 z-0 items-center" data-id="element-275">
            <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="w-full h-1 bg-gradient-to-r from-sage-400 via-naranja-300 to-naranja-500 rounded-full origin-left" data-id="element-276" />
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} className="grid grid-cols-1 md:grid-cols-3 gap-5 relative z-10" data-id="element-277">
            {timeline.map((item, idx) => <motion.div key={idx} variants={cardVariants} whileHover={{
            y: -6,
            scale: 1.03
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 20
          }} className={`bg-white p-6 rounded-2xl border-2 ${item.borderColor} ${item.shadow} relative cursor-default`} data-id="element-278">
                {/* Step number circle */}
                <div className={`absolute -top-3 -right-3 w-8 h-8 ${item.accent} rounded-full flex items-center justify-center text-white text-xs font-black shadow-md`} data-id="element-279">
                  {idx + 1}
                </div>

                <div className="flex items-center gap-2 mb-4" data-id="element-280">
                  <div className={`${item.badgeBg} px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1.5`} data-id="element-281">
                    {item.icon}
                    {item.day}
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-2" data-id="element-282">
                  <span className="text-2xl" data-id="element-283">{item.emoji}</span>
                  <h3 className="text-lg font-black text-charcoal-900" data-id="element-284">
                    {item.title}
                  </h3>
                </div>
                <p className="text-charcoal-700 text-sm leading-relaxed" data-id="element-285">
                  {item.desc}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}